// Teacher DNA answer codes, shared by the onboarding wizard and the profile's
// Edit my DNA form. Codes match the backend answer enums 1:1; labels live in
// i18n under pages.teacherOnboarding.*.

export type TeacherVoice1 = "warm" | "formal" | "prov";

// Adaptive second voice pick, branched off voice1.
export type TeacherVoice2 =
  | "warm-soft"
  | "warm-brisk"
  | "formal-warm"
  | "formal-pure"
  | "prov-curious"
  | "prov-edge";

export type TeacherIllustration = "rich" | "clean";
export type TeacherStructure = "problem" | "linear";

// ─── Single-choice option ids ───

export const VOICE1_OPTIONS: TeacherVoice1[] = ["warm", "formal", "prov"];

// voice1 answer codes differ from their i18n option keys.
export const VOICE1_OPTION_KEY: Record<TeacherVoice1, string> = {
  warm: "relatable",
  formal: "structure",
  prov: "challenge",
};
export const ILLUSTRATION_OPTIONS: TeacherIllustration[] = ["rich", "clean"];
export const STRUCTURE_OPTIONS: TeacherStructure[] = ["problem", "linear"];

// Depends on voice1. Order [soft, bold]: soft lowers persona_intensity, bold raises it.
export const VOICE2_OPTIONS: Record<TeacherVoice1, TeacherVoice2[]> = {
  warm: ["warm-soft", "warm-brisk"],
  formal: ["formal-warm", "formal-pure"],
  prov: ["prov-curious", "prov-edge"],
};
